import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdditionalsAccountingPolicyPopupComponent } from './additionals-accounting-policy-popup/additionals-accounting-policy-popup.component';

@Component({
  selector: 'app-additionals-accounting-policy',
  templateUrl: './additionals-accounting-policy.component.html',
  styleUrls: ['./additionals-accounting-policy.component.scss']
})
export class AdditionalsAccountingPolicyComponent implements OnInit {

  dataSource : any = [];

  column: string[] = ['title', 'status', 'action']

  constructor(private spinner: NgxSpinnerService, private dialog: MatDialog) {}
subModule='Policy';
  ngOnInit(): void {
  //   this.spinner.hide();
   }

  // addNewNote(): void {
  //   console.log('Opening dialog');
  //   this.dialog
  //     .open(AdditionalsAccountingPolicyPopupComponent, {
  //       disableClose: true,
  //     })
  //     .afterClosed()
  //     .subscribe((result: boolean) => {
  //       if (result) {
  //         console.log('Dialog closed with result:', result);
  //       }
  //   });
  // }

  
}

